import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Headphones } from "lucide-react";

const links = [
    { to: "/", label: "Home", testid: "nav-home" },
    { to: "/episodes", label: "Episodes", testid: "nav-episodes" },
    { to: "/voices", label: "Voices", testid: "nav-voices" },
    { to: "/about", label: "About", testid: "nav-about" },
    { to: "/press", label: "Press Kit", testid: "nav-press" },
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 bg-paper/90 backdrop-blur-md border-b-2 border-ink"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between gap-4">
                <Link
                    to="/"
                    data-testid="nav-logo"
                    className="flex items-center gap-3 shrink-0"
                    onClick={() => setOpen(false)}
                >
                    <span className="font-sub font-black text-lg sm:text-xl tracking-tight text-ink">
                        BOMGAY<span className="text-pink">.in</span>
                    </span>
                </Link>

                <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={l.testid}
                            className={({ isActive }) =>
                                `font-mono-brand text-xs uppercase tracking-[0.18em] transition-colors duration-200 hover:text-pink ${
                                    isActive ? "text-pink" : "text-ink"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <Link
                        to="/episodes"
                        data-testid="header-listen-btn"
                        className="hidden sm:inline-flex items-center gap-2 bg-pink text-cream font-sub font-bold text-sm px-5 py-2.5 border-2 border-ink hard-shadow-sm transition-transform duration-200 hover:-translate-y-0.5"
                    >
                        <Headphones className="w-4 h-4" />
                        Listen Now
                    </Link>
                    <button
                        data-testid="mobile-menu-toggle"
                        aria-label="Toggle menu"
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden p-2 border-2 border-ink bg-cream text-ink"
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>

            {open && (
                <nav
                    data-testid="mobile-menu"
                    className="lg:hidden border-t-2 border-ink bg-paper px-5 py-4 flex flex-col gap-4"
                    aria-label="Mobile"
                >
                    {links.map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            data-testid={`mobile-${l.testid}`}
                            onClick={() => setOpen(false)}
                            className={`font-sub font-bold text-lg ${
                                location.pathname === l.to ? "text-pink" : "text-ink"
                            }`}
                        >
                            {l.label}
                        </Link>
                    ))}
                </nav>
            )}
        </header>
    );
}
